export const ROOT = "/";
export const LOGIN = "/auth/login";

export const USER_DETAIL = "/edit-user/:id";
